
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
import "styles/globals.css";
import type { AppProps } from "next/app";
import Layout from "components/Layout/Layout";
import NotificationContextProvider from "context/notification/NotificationContextProvider";
import AuthContextProvider from "context/auth/AuthContextProvider";
import useVh from "hooks/useVH";
import LocationContextProvider from "context/location/LocationContextProvider";
import PlaceContextProvider from "context/place/PlaceContextProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

const MyApp = ({ Component, pageProps }: AppProps) => {
  useVh();

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <NotificationContextProvider>
          <LocationContextProvider>
            <PlaceContextProvider>
              <AuthContextProvider>
                <Layout>
                  <Component {...pageProps} />
                </Layout>
              </AuthContextProvider>
            </PlaceContextProvider>
          </LocationContextProvider>
        </NotificationContextProvider>
      </QueryClientProvider>
    </>
  );
};

const __Page_Next_Translate__ = MyApp;


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: true,
// @ts-ignore
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
    });
// @ts-ignore
  